import React from 'react';
import T from 'prop-types';
import Helmet from 'react-helmet';
import { VisitorIdentification } from '@sitecore-jss/sitecore-jss-react';
import AppPlaceholders from '_AppPlaceholders';
import AppContainer from '_AppContainer';
import { getIsFirstPageLoad } from 'core/browserStorage';

import { recursiveFilterPlaceholders } from 'core/utils/sitecore-utils';
import { findAllByKey } from 'core/utils/global-utils';

import config from 'jss-boilerplate/temp/config.js';
import { DbAPIComponents } from 'jss-components/t06-dashboard/constants/Dashboard.const';

const Layout = ({ route, context: sitecoreContext }) => {
	const { fields } = route;
	route.placeholders = recursiveFilterPlaceholders(route.placeholders);
	const [dbIntersectionComponents, setDbIntersectionComponents] =
		React.useState([]);

	React.useEffect(() => {
		if (route.name === 'Home' && getIsFirstPageLoad() === '') {
			if (!!route?.placeholders[`jss-main`][0]?.placeholders) {
				const componentNameArray = findAllByKey(
					route?.placeholders[`jss-main`][0]?.placeholders,
					'componentName',
				);
				const uniqueComponentNameArray = [...new Set(componentNameArray)];
				const dbAPIComponents = Object.values(DbAPIComponents);
				const intersection = dbAPIComponents.filter((elem) =>
					uniqueComponentNameArray.includes(elem),
				);
				setDbIntersectionComponents(intersection);
			}
		}
	}, [route]);

	return (
		<AppContainer
			{...{
				sitecoreContext,
				routeFields: route.fields,
				dbIntersectionComponents,
			}}
		>
			{/* React-helmet enables setting <head> contents, like title and OG meta tags */}
			<Helmet>
				<title>
					{fields?.navigationTitle?.value ??
						fields?.pageTitle?.value ??
						'Australian Super'}
				</title>
				<link
					rel="stylesheet"
					type="text/css"
					media="screen"
					href={`${config.externalServices?.greenIdAssetsUrl}/df/assets/stylesheets/greenid.css`}
				/>

				<script
					src={`${config.externalServices?.greenIdAssetsUrl}/df/javascripts/greenidConfig.js`}
					type="text/javascript"
				/>
				<script
					src={`${config.externalServices?.greenIdAssetsUrl}/df/javascripts/greenidui.min.js`}
					type="text/javascript"
				/>
			</Helmet>

			<AppPlaceholders rendering={route} />
		</AppContainer>
	);
};

Layout.propTypes = {
	context: T.object.isRequired,
	route: T.object.isRequired,
};

export default Layout;
